import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LicenseURLCardModule } from '@portal-core/auth/components/license-url-card/license-url-card.module';
import { AboutFooterModule } from '@portal-core/layout/components/about-footer/about-footer.module';
import { LicenseURLPageComponent } from './license-url-page.component';

@NgModule({
  declarations: [
    LicenseURLPageComponent
  ],
  imports: [
    AboutFooterModule,
    CommonModule,
    LicenseURLCardModule
  ],
  exports: [
    LicenseURLPageComponent
  ]
})
export class LicenseURLPageModule { }
